import React, { useContext } from "react";
import { Fade } from "react-awesome-reveal";
import bg from "../../assets/bgno.webp";
import arrow from "../../assets/arrow.png";
// Language
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

function Hero() {
  const { language } = useContext(LanguageContext);
  const translations = language === "en" ? en.home.hero : no.home.hero;

  return (
    <div
      className="min-h-[calc(100vh-92px)] bg-black bg-no-repeat bg-[center_-6rem] bg-[length:1600px] relative flex items-center"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="overlay"></div>
      <div className="relative z-10 w-full flex flex-col items-center gap-4">
        <Fade direction="up">
          <h3 className="font-dancing text-3xl md:text-4xl font-extralight">
            {translations[1]}
          </h3>
        </Fade>
        <Fade delay={100} direction="up">
          <h1 className="font-heading font-extrabold text-[calc(2rem+4vw)] md:text-[calc(4rem+2vw)] lg:text-[6rem] text-main-light">
            {translations[2]}
          </h1>
        </Fade>
        <div className="underline gradient"></div>
        <Fade delay={200} direction="up">
          <p className="font-copy text-lg text-center pt-4">
            {translations[3]}
          </p>
          <p className="font-copy text-lg text-center pt-4 font-semibold">
            {translations[4]}
          </p>
        </Fade>
        <Fade delay={300} direction="up">
          <a
            href="https://instantiris.onlinebooq.net/"
            className="cta mt-4"
          >
            {language === "en"
              ? en.home.button.bookNow
              : no.home.button.bookNow}
          </a>
        </Fade>
        <Fade delay={400} direction="up">
          <div className="mt-12">
            <img src={arrow} alt="arrow" className="h-[60px] w-[60px]" />
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default Hero;
